export const BACKOFF_BASE_MS = 1000;
export const BACKOFF_CAP_MS = 600_000; // 10 minutes
export const REFRESH_LEAD_MS = 90_000; // refresh ~90s before expiry

/** Exponential backoff: 1s, 2s, 4s, … capped at 10 min. attempt is 0-based. */
export function nextBackoffMs(attempt: number): number {
  if (attempt < 0) attempt = 0;
  const ms = BACKOFF_BASE_MS * 2 ** attempt;
  return Math.min(ms, BACKOFF_CAP_MS);
}

// Retry budget: give up reconnecting only once BOTH bounds are exhausted —
// "10 tries OR 30 minutes, whichever is MORE" (the more generous bound).
export const MAX_RECONNECT_ATTEMPTS = 10;
export const MAX_RECONNECT_ELAPSED_MS = 1_800_000; // 30 minutes

/**
 * Stop retrying only once BOTH bounds are exhausted: at least
 * MAX_RECONNECT_ATTEMPTS attempts AND at least MAX_RECONNECT_ELAPSED_MS since
 * the failure streak began. `firstFailureAt` is null before the first failure.
 */
export function shouldStopRetrying(
  attempt: number,
  firstFailureAt: number | null,
  now: number
): boolean {
  if (firstFailureAt === null) return false;
  return attempt >= MAX_RECONNECT_ATTEMPTS && now - firstFailureAt >= MAX_RECONNECT_ELAPSED_MS;
}

/** True when `expiresMs` is within `leadMs` of `now` (or already past). */
export function isNearExpiry(expiresMs: number | null, now: number, leadMs = REFRESH_LEAD_MS): boolean {
  if (expiresMs == null) return false;
  return now >= expiresMs - leadMs;
}
